/** @format */

import React from 'react';

export const CommonContext = React.createContext();
export const CommonDispatcherContext = React.createContext();

function CommonProvider({ children }) {
  const [state, setState] = React.useState({});

  return (
    <CommonContext.Provider value={state}>
      <CommonDispatcherContext.Provider value={setState}>
        {children}
      </CommonDispatcherContext.Provider>
    </CommonContext.Provider>
  );
}

export { CommonProvider };
